// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/menu-item","root":"menu-item-m__root__1cMIs mdc-list__mdc-list-item__3Vksq","active":"menu-item-m__active__3pSJ-"};